import React, { useState, useEffect } from 'react';
import { pasta1 } from '../../assets/images/images';
import Icon from '../../component/Icon';
import { useSelector, useDispatch } from 'react-redux';
import * as Action from '../../store/actions';
import { Link } from 'react-router-dom';
import * as actionCreators from '../../store/actionCreators'
function Cart() {
  const state = useSelector((state) => state.cart);
  const [totalAmount, setTotalAmount] = useState(0)
  const dispatch = useDispatch()

  const removeFromCart = data => {
    dispatch(actionCreators.removeFromCart(data))
  }

  useEffect(() => {
    if(state.cartItems.length === 0)return;
    const res = state.cartItems.map(el => el.total).reduce((prev, cur) => {
      return prev + cur;
    }, 0)
    setTotalAmount(res)
  }, [state.cartItems])

  return (
    <div className='p-[5rem]'>
      <div className='w-full text-center mb-10 font-[700] text-greyPrimary font-Poppins text-4xl xl:text-5xl'>
        <h1>Your Cart</h1>
      </div>
      {/* TABLE */}
      <div className='w-[60vw] mb-16 overflow-x-auto border min-h-[20rem]  mx-auto my-0'>
        {/* TABLE HEADING */}
        <div className='flex flex-nowrap mb-8 py-2 w-full '>
          <h2 className='basis-[15rem] text-greyPrimary shrink-0 text-center font-[600]'>
            Item
          </h2>
          <h2 className='basis-[15rem] text-greyPrimary shrink-0 text-center font-[600]'>
            Quantity
          </h2>
          <h2 className='basis-[8rem] text-greyPrimary shrink-0 text-center font-[600]'>
            Price
          </h2>
          <h2 className='basis-[8rem] text-greyPrimary shrink-0 text-center font-[600]'>
            Total
          </h2>
        </div>
        {state.cartItems.length === 0 && (
          <div>
            <h2 className='text-xl text-center text-greyPrimary font-semibold'>Cart is empty</h2>
          </div>
        )}
        {/* CART PRODUCTS */}
        {state.cartItems.length !== 0 &&
          state.cartItems.map((el, id) => {
            return <CartProduct key={id} productData={el} removeProduct={() => removeFromCart(el)} />;
          })}
      </div>
      <div className='w-[60vw] flex justify-end gap-4 text-2xl font-semibold p-4 mb-16   mx-auto my-0'>
        <h2>Total: </h2>
        <h2>Rs {totalAmount}</h2>
      </div>
      {/* CONFIRM BUTTON */}
      <Link
        to='/checkout'
        className='flex p-2 w-max px-4 hover:opacity-80 transition ease-out uppercase mx-auto my-0  rounded-lg items-center gap-2 bg-greyPrimary'
      >
        <Icon name='tickBox' className='w-6 h-6 fill-white' />
        <h2 className='font-[600] text-white'>Confirm Order</h2>
      </Link>
    </div>
  );
}

function CartProduct(props) {
  const [numOfItems, setNumOfItems] = useState(1);
  const dispatch = useDispatch();
  const updateNoOfItems = (type) => {
    if (type === 'add') {
      dispatch({ type: Action.INCREMENT, payload: props.productData.id });
    } else if (type === 'sub') {
      dispatch({ type: Action.DECREMENT, payload: props.productData.id });
    }
  };
  return (
    <div className='flex flex-nowrap items-center p-2 w-full'>
      <div className='flex gap-4 basis-[15rem] shrink-0 items-center'>
        {/* IMAGE */}
        <img
          src={pasta1}
          alt='pasta'
          className='block w-24 h-24 object-cover'
        />
        {/* DESCRIPTION */}
        <div>
          <h2 className='font-[600]'>{props.productData.title}</h2>
          <button onClick={props.removeProduct} className='text-red-400'>Remove</button>
        </div>
      </div>
      <div className='flex gap-4 justify-center basis-[15rem] shrink-0'>
        <button
          onClick={() => updateNoOfItems('add')}
          className='w-8 h-8 bg-greyPrimary text-white text-2xl rounded-full'
        >
          +
        </button>
        <h2 className='text-greyPrimary text-lg'>
          {props.productData.noOfItems}
        </h2>
        <button
          onClick={() => updateNoOfItems('sub')}
          className='w-8 h-8 bg-greyPrimary text-white text-2xl rounded-full'
          disabled={numOfItems < 1}
        >
          -
        </button>
      </div>
      <div className=' basis-[8rem]  shrink-0'>
        <h1 className='font-[600] text-center'>
          Rs {props.productData.price}.00
        </h1>
      </div>
      <div className=' basis-[8rem]  shrink-0'>
        <h1 className='font-[600] text-center'>
          Rs {props.productData.total}.00
        </h1>
      </div>
    </div>
  );
}

export default Cart;
